import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-widgets-enlarged-component',
  templateUrl: './widgets-enlarged-component.component.html',
  styleUrls: ['./widgets-enlarged-component.component.scss']
})
export class WidgetsEnlargedComponentComponent implements OnInit {

  chartTitle :string;
  showingChartId: string;
  passedDataSource : any;
  constructor(
    public dialogRef: MatDialogRef<WidgetsEnlargedComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, ) { }

  ngOnInit() {
    this.showingChartId = this.data.chartId;
    this.chartTitle = this.data.chartTitle;
    this.passedDataSource = this.data.dataSource;   
  }

  onNoClick(){
    this.dialogRef.close();
  }

}
